import { Component, Input, TemplateRef } from "@angular/core";

export interface AccordionItem {
  name: string,
  value: string | boolean | null,
  template?: TemplateRef<any>;
  isImage?: boolean;
}

@Component({
  selector: 'cosmos-expandable-panel',
  templateUrl: './expandable-panel.component.html',
  styleUrls: ['./expandable-panel.component.scss'],
})
export class ExpandablePanelComponent {
  @Input() public panelTitle: string;
  @Input() public accordionItems: AccordionItem[];
  @Input() public numberOfColumns: 2 | 3;
  @Input() public hasImage: boolean;
  public areDetailsOpened = true;
}
